import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Utility } from '../../common/utility';
import { BaseUrl } from '../../shared/urls/base.url';
import { UserUrl } from '../../shared/urls/user.url';
import { AppConstants } from '../../shared/constants/constants'
import { BaseService } from '../../shared/services/base.service';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { AuthService } from '../../shared/services/auth.service';
import { ActiveLinkService } from './active-link.service';
import { DialogService } from '../../shared/services/dialog.service';
import { AppMessages } from '../../shared/constants/messages';

@Component({
  selector: 'app-active',
  templateUrl: './active-link.component.html',
  providers: [ActiveLinkService]
})
export class ActiveLinkComponent implements OnInit {
  public appConstants = AppConstants;
  authConfig = BaseUrl.AUTH_CONFIG;
  public messageText: string;
  public messageType: string;
  userId: string;
  constructor(private router: Router,
    private activeRouter: ActivatedRoute,
    private baseService: BaseService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    public dialogServie: DialogService,
    private activeLinkService: ActiveLinkService) {
  }
  ngOnInit() {
    this.userId = this.activeRouter.snapshot.queryParams[this.appConstants.activeLink.userId];
    const token = this.activeRouter.snapshot.queryParams[this.appConstants.activeLink.token];

    if (this.userId && token) {
      const activeUser = {
        userId: this.userId,
        token: token,
        callBackUrl: BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL
      };
      this.activeLinkService.emailConfirm(activeUser).subscribe(
        (result) => {
          if (result) {
            const data = result.json();
            this.messageText = data['message'];
            this.messageType = data['type'];
          }
        }
      );
    }
  }
  login() {
    this.router.navigate(["/login"]);
  }

  createPassword()
  {
    // const userinfo = {
    //   userId: this.userId,
    //   callBackUrl: BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL
    // };
    //this.activeLinkService.createPassword(userinfo).subscribe();
    this.router.navigate(["/create-password", this.userId]);
  }
  resendConfirmEmail() {
    const data = {
      userId: this.userId,
      callBackUrl: BaseUrl.APP_URL + UserUrl.GET_APP_ACTIVE_LINK_URL
    };
    this.activeLinkService.resendEmailConfirm(data).subscribe(
      (result) => {
        if (result) {
          const resData = result.json();
          if (resData.statusCode === 200) {
            this.dialogServie.openSuccessDialog({ message: resData.message });
          }
        }
      }
    );
  }
}




// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/active-link/active-link.component.ts